import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';
import { Row, REFACTOR_DATE } from '../../Resources';
import ActivitiesRegistrationHeader from '../../ActivitiesRegistrationHeader';

import { convertToReal } from 'helpers/converters';

export default function PayrollUpdate({ activityData, lastRegister, newRegister, payroll }) {
  if(moment(activityData?.updatedAt, 'YYYY-MM-DD HH:mm:ss').isBefore(REFACTOR_DATE)) {
    return (
      <Grid container>
        <Grid xs={12}>
          <ActivitiesRegistrationHeader
            activityData={activityData}
          />
          <Grid container style={{ marginTop: 10 }}>
            <Grid xs={12} style={{ padding: 5 }}>
              <Typography color='primary' style={{ marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
                <b>Folha de Pagamento Anterior</b>
              </Typography>
              <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
                <Row>
                  <Typography color='primary'>
                    <b>Funcionário</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {lastRegister?.name}
                  </Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Data de vencimento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ marginLeft: 15 }}>
                    {moment(lastRegister?.dueDate).format('DD/MM/YYYY')}
                  </Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary'>{convertToReal(lastRegister?.amount)}</Typography>
                </Row>
              </Grid>
            </Grid>
            <Grid xs={12} style={{ padding: 5 }}>
              <Typography color='primary' style={{ marginTop: 10, marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
                <b>Folha de Pagamento Atual</b>
              </Typography>
              <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
                <Row>
                  <Typography color='primary'>
                    <b>Funcionário</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {payroll?.name}
                  </Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Data de vencimento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ marginLeft: 15 }}>
                    {moment(payroll?.dueDate).format('DD/MM/YYYY')}
                  </Typography>
                </Row>
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary'>{convertToReal(payroll?.amount)}</Typography>
                </Row>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
              <b>Folha de Pagamento Anterior</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(lastRegister).includes('name') && (
                <Row>
                  <Typography color='primary'>
                    <b>Funcionário</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {lastRegister?.name}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('dueDate') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data de vencimento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ marginLeft: 15 }}>
                    {moment(lastRegister?.dueDate).format('DD/MM/YYYY')}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('amount') && (
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary'>{convertToReal(lastRegister?.amount)}</Typography>
                </Row>
              )}
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginTop: 10, marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
              <b>Folha de Pagamento Atual</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(newRegister).includes('name') && (
                <Row>
                  <Typography color='primary'>
                    <b>Funcionário</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ whiteSpace: 'nowrap', marginLeft: 5 }}>
                    {newRegister?.name}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('dueDate') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data de vencimento</b>
                  </Typography>
                  <Typography color='textSecondary' style={{ marginLeft: 15 }}>
                    {moment(newRegister?.dueDate).format('DD/MM/YYYY')}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('amount') && (
                <Row>
                  <Typography color='primary'>
                    <b>Valor</b>
                  </Typography>
                  <Typography color='textSecondary'>{convertToReal(newRegister?.amount)}</Typography>
                </Row>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

PayrollUpdate.propTypes = {
  lastRegister: PropTypes.object.isRequired,
  activityData: PropTypes.object.isRequired,
  payroll: PropTypes.object.isRequired
};